document.addEventListener("DOMContentLoaded", function () {
    const tabButtons = document.querySelectorAll(".collections-tab");
    const tabContents = document.querySelectorAll(".collections-tab-content");

    tabButtons.forEach((tab, index) => {
      tab.addEventListener("click", function () {
        tabButtons.forEach(btn => btn.classList.remove("active"));
        tabContents.forEach(content => content.classList.remove("active"));

        tab.classList.add("active");
        const tabIndex = tab.getAttribute("data-tab-index");
        const matchingContent = document.querySelector(
          `.collections-tab-content[data-tab-content-index="${tabIndex}"]`
        );
        if (matchingContent) {
          matchingContent.classList.add("active");
        }
      });
    });
  });